module.exports = __webpack_public_path__ + "img/Butterfly_00370.1bafe773.png";